"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsurerRepository = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const typeorm_1 = require("@nestjs/typeorm");
const typeorm_2 = require("typeorm");
const constants_1 = require("../../.../../../../../../libs/service-lib/src/lib/constants");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const entity_service_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/entity-service.utils");
const insurer_address_entity_1 = require("../../../../service-lib/src/lib/entities/insurer-address.entity");
const insurer_contact_entity_1 = require("../../../../service-lib/src/lib/entities/insurer-contact.entity");
const insurer_entity_1 = require("../../../../service-lib/src/lib/entities/insurer.entity");
const look_up_entity_1 = require("../../../../service-lib/src/lib/entities/look-up.entity");
const response_util_1 = require("../../../../service-lib/src/lib/response.util");
const constants_2 = require("../../../../service-lib/src/lib/constants");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
let InsurerRepository = class InsurerRepository {
    createQueryRunner() {
        throw new Error("Method not implemented.");
    }
    constructor(insurerRepository, insurerContactRepository, insurerAddressRepository, lookUpRepository, entityService, scopeService) {
        this.insurerRepository = insurerRepository;
        this.insurerContactRepository = insurerContactRepository;
        this.insurerAddressRepository = insurerAddressRepository;
        this.lookUpRepository = lookUpRepository;
        this.entityService = entityService;
        this.scopeService = scopeService;
    }
    /** Adds a new insurer using a transaction manager. */
    async addInsurer(queryRunner, createInsurerDto) {
        try {
            const insurer = queryRunner.manager.create(insurer_entity_1.Insurer, createInsurerDto);
            return await queryRunner.manager.save(insurer);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToAddInsurer || error.message));
        }
    }
    /** Fetches an insurer by its ID. */
    async fetchInsurerById(insurerId) {
        try {
            const insurer = await this.insurerRepository.findOne({
                where: { id: insurerId },
                relations: ["insurerAddresses.address", "status"],
            });
            if (!insurer) {
                throw new common_1.NotFoundException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.insurerNotFound));
            }
            return insurer;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.insurerNotFound));
        }
    }
    /** Retrieves all insurers with their associated addresses. */
    async fetchAllInsurersWithAddress(page, limit, searchArray, sort, searchBy, userId) {
        const relations = [
            "insurerAddresses", // ← parent
            "insurerAddresses.address", // ← child
            "insurerAddresses.address.cityId",
            "insurerAddresses.address.stateId",
            "status",
            "companyTag",
            "companyType",
        ];
        const status = await this.lookUpRepository.findOne({
            where: { lookUpKey: constants_1.DEFAULT_INSURER_STATUS_ACTIVE_KEY },
        });
        const whereCondition = {
            statusLid: status?.id ?? undefined,
        };
        // const { data, count } = await this.entityService.fetchEntityList(
        //   "insurer",
        //   page,
        //   limit,
        //   sort.length > 0 ? sort : [{ field: "id", order: "ASC" }],
        //   relations,
        //   whereCondition,
        //   undefined,
        //   searchArray.length === 0 ? [] : searchArray,
        //   undefined,
        //   searchBy,
        //   InsurerSearchObject
        // );
        const { data, count } = await this.scopeService.validateScope({
            entity: "insurer",
            page: page,
            limit: limit,
            sort: sort && sort.length > 0 ? sort : [{ field: "id", order: "ASC" }],
            relations: relations,
            where: whereCondition,
            select: undefined,
            searchArray: searchArray && searchArray?.length === 0 ? [] : searchArray,
            userFilter: undefined,
            searchString: searchBy,
            searchOn: constants_2.InsurerSearchObject,
        }, userId, "insurer");
        const transformedData = data.map((insurer) => ({
            id: insurer.id,
            insurerName: insurer.insurerName,
            displayName: insurer.displayName,
            status: insurer.status
                ? {
                    id: insurer.status.id,
                    lookUpValue: insurer.status.lookUpValue,
                }
                : null,
            companyTag: insurer.companyTag
                ? {
                    id: insurer.companyTag.id,
                    lookUpValue: insurer.companyTag.lookUpValue,
                }
                : null,
            companyType: insurer.companyType
                ? {
                    id: insurer.companyType.id,
                    lookUpValue: insurer.companyType.lookUpValue,
                }
                : null,
            insurerAddresses: insurer.insurerAddresses?.map((address) => ({
                id: address.id,
                address1: address.address?.address1,
                city: address.address?.cityId,
                state: address.address?.stateId,
                country: address.address?.countryId,
                phoneNumber: address.address?.phoneNumber,
            })),
        }));
        return { data: transformedData, count };
    }
    /** Saves an insurer-company address mapping to the database. */
    async addInsurerAddressMap(insurerAddress) {
        try {
            const insurerAddressData = this.insurerAddressRepository.create(insurerAddress);
            await this.insurerAddressRepository.save(insurerAddressData);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, messages_1.errorMessages.failedToSaveAddressMapping || error.message));
        }
    }
    /** Finds the insurer company and address data mapping in InsurerAddress Table */
    async findInsurerCompanyAddressMap(companyId, addressId) {
        return this.insurerAddressRepository.findOne({
            where: {
                insurer: { id: companyId },
                address: { id: addressId },
            },
        });
    }
    // saves insurer companyid and addressid in InsurerAddress Table */
    async addInsurerAddress(queryRunner, insurerAddress) {
        try {
            await queryRunner.manager.save(insurerAddress);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToSaveAddressMapping || error.message));
        }
    }
    /** Saves an insurer-company contact mapping to the database. */
    async addInsurerContact(insurerContact) {
        try {
            await this.insurerContactRepository.save(insurerContact);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToSaveContactMapping || error.message));
        }
    }
    /** Remove an insurer contact details */
    async delinkInsurerContactMapping(docObject) {
        try {
            await this.insurerContactRepository.delete(docObject);
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.insurerContactMappingDeletionFailed || error.message));
        }
    }
    /** Updates an existing insurer in the database. */
    async modifyInsurer(queryRunner, insurerId, updateInsurerDto) {
        try {
            const insurer = await queryRunner.manager.findOne(insurer_entity_1.Insurer, {
                where: { id: insurerId },
            });
            if (!insurer) {
                throw new common_1.NotFoundException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.insurerNotFound));
            }
            // Update the insurer details
            await queryRunner.manager.update(insurer_entity_1.Insurer, insurerId, {
                ...updateInsurerDto,
            });
            const updatedInsurer = await queryRunner.manager.findOne(insurer_entity_1.Insurer, {
                where: { id: insurerId },
            });
            if (!updatedInsurer) {
                throw new common_1.NotFoundException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, messages_1.errorMessages.insurerNotFound));
            }
            return updatedInsurer;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToModifyInsurer));
        }
    }
    /** Removes an insurer from the database by its ID. */
    async softDeleteInsurer(insurerId) {
        try {
            await this.insurerRepository.update(insurerId, {
                deletedAt: new Date(), // Set the current timestamp
            });
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToDeleteInsurer || error.message));
        }
    }
    async fetchInsurerByIdWithDetails(insurerId) {
        const insurer = await this.insurerRepository.findOne({
            where: { id: insurerId },
            relations: [
                "insurerAddresses",
                "insurerAddresses.address.addressType",
                "insurerContacts",
                "insurerContacts.contact",
                "insurerContacts.contact.contactAddresses",
                "insurerContacts.contact.contactAddresses.address.addressType",
                "companyTag",
                "companyType",
                "status",
                "isLife",
            ],
        });
        if (!insurer) {
            throw new common_1.NotFoundException(`Insurer with ID ${insurerId} not found`);
        }
        return await this.transformInsurer(insurer);
    }
    /** Fetches insurers based on the given name. */
    async findInsurerByName(name) {
        try {
            const insurers = await this.insurerRepository.find({
                where: {
                    insurerName: (0, typeorm_2.ILike)(`%${name}%`),
                },
            });
            return insurers;
        }
        catch (error) {
            throw new common_1.InternalServerErrorException(`Failed to find insurer with name "${name}".`);
        }
    }
    /** Fetches the total number of active insurers based on the given status ID. */
    async getTotalActiveInsurers(statusLid) {
        try {
            return await this.insurerRepository.count({
                where: {
                    statusLid: statusLid,
                },
            });
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchInsurers || error.message));
        }
    }
    /** Fetches a paginated list of insurers based on various filters. */
    async fetchInsurerList(page, limit, search, sortBy, sortOrder, userId) {
        try {
            const status = await this.lookUpRepository.findOne({
                where: { lookUpKey: constants_1.DEFAULT_INSURER_STATUS_ACTIVE_KEY },
            });
            const { data, count } = await this.scopeService.validateScope({
                entity: "insurer",
                page,
                limit,
                sort: [{ field: sortBy, order: sortOrder?.toUpperCase() === "DESC" ? "DESC" : "ASC" }],
                relations: [],
                where: {
                    // insurerName: search ? ILike(`%${search}%`) : undefined,
                    statusLid: status?.id ?? undefined,
                },
                select: ["id", "insurerName", "displayName"],
                searchArray: [],
                userFilter: undefined,
                searchString: undefined,
                searchOn: undefined,
            }, userId, "insurer");
            return { data: data, total: count };
        }
        catch (error) {
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchInsurers || error.message));
        }
    }
    /** Fetches insurer details based on various conditions. */
    async fetchInsurerDetails(fields, relations, whereCondition) {
        try {
            const entityName = constants_1.DEFAULT_INSURER_ENTITY_NAME;
            const data = await this.entityService.getListOfValues(entityName, fields, whereCondition, relations);
            if (!data || data.length === 0) {
                throw new common_1.NotFoundException(messages_1.errorMessages.insurerNotFound);
            }
            return data;
        }
        catch (error) {
            console.error("Error fetching insurer details:", error);
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException((0, response_util_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, messages_1.errorMessages.failedToFetchInsurer));
        }
    }
    transformInsurer(insurerOrInsurers) {
        const mapAddress = (addressMapping) => ({
            id: addressMapping.address?.id,
            addressTypeLid: addressMapping.address?.addressTypeLid,
            addressType: mapLookup(addressMapping.address?.addressType),
            address1: addressMapping.address?.address1,
            countryId: addressMapping.address?.countryId
                ? {
                    name: addressMapping.address.countryId.name,
                    isoCode: addressMapping.address.countryId.isoCode,
                    id: addressMapping.address.countryId.id,
                }
                : null,
            stateId: addressMapping.address?.stateId
                ? {
                    name: addressMapping.address.stateId.name,
                    stateCode: addressMapping.address.stateId.stateCode,
                    id: addressMapping.address.stateId.id,
                }
                : null,
            cityId: addressMapping.address?.cityId
                ? {
                    name: addressMapping.address.cityId.name,
                    id: addressMapping.address.cityId.id,
                }
                : null,
            address2: addressMapping.address?.address2,
            area: addressMapping.address?.area,
            pinCode: addressMapping.address?.pinCode,
            phoneNumber: addressMapping.address?.phoneNumber,
            alternatePhoneNumber: addressMapping.address?.alternatePhoneNumber,
            email: addressMapping.address?.email,
            supportNumber: addressMapping.address?.supportNumber,
            createdBy: addressMapping.address?.createdBy,
            updatedBy: addressMapping.address?.updatedBy,
            createdAt: addressMapping.address?.createdAt,
            updatedAt: addressMapping.address?.updatedAt,
        });
        const mapContact = (contactMapping) => ({
            id: contactMapping.contact?.id,
            salutationLid: contactMapping.contact?.salutationLid,
            firstName: contactMapping.contact?.firstName,
            lastName: contactMapping.contact?.lastName,
            middleName: contactMapping.contact?.middleName,
            displayName: contactMapping.contact?.displayName,
            companyId: contactMapping.contact?.companyId,
            companyLocationId: contactMapping.contact?.companyLocationId,
            companyBranchId: contactMapping.contact?.companyBranchId,
            tagLid: contactMapping.contact?.tagLid,
            contactTypeLid: contactMapping.contact?.contactTypeLid,
            department: contactMapping.contact?.department,
            designation: contactMapping.contact?.designation,
            reportingToId: contactMapping.contact?.reportingToId,
            assistantId: contactMapping.contact?.assistantId,
            emailId: contactMapping.contact?.emailId,
            phone: contactMapping.contact?.phone,
            remarks: contactMapping.contact?.remarks,
            statusLid: contactMapping.contact?.statusLid,
            contactAddresses: contactMapping.contact?.contactAddresses?.map(mapAddress),
        });
        const mapLookup = (lookup) => ({
            id: lookup?.id,
            lookUpValue: lookup?.lookUpValue,
        });
        const transform = (insurer) => ({
            id: insurer.id,
            insurerName: insurer.insurerName,
            displayName: insurer.displayName,
            companyTypeLid: insurer.companyTypeLid,
            companyTag: mapLookup(insurer.companyTag),
            companyType: mapLookup(insurer.companyType),
            isLife: mapLookup(insurer.isLife),
            status: mapLookup(insurer.status),
            website: insurer.website,
            companyTagLid: insurer.companyTagLid,
            remarks: insurer.remarks,
            insureCode: insurer.insureCode,
            policy: [],
            insurerAddresses: insurer.insurerAddresses?.map(mapAddress),
            insurerContacts: insurer.insurerContacts?.map(mapContact),
        });
        return Array.isArray(insurerOrInsurers)
            ? insurerOrInsurers.map(transform)
            : transform(insurerOrInsurers);
    }
    async getEntityTableMapIds(entity, select, whereCondition) {
        try {
            const data = await this.entityService.getEntityMapByIds(entity, select, whereCondition);
            return data;
        }
        catch (error) {
            return [];
        }
    }
    async deleteEntityTableMapIds(entity, deleteIds, select, deletionType) {
        try {
            await this.entityService.deleteEntityMapByIds(entity, deleteIds, select, deletionType);
        }
        catch (error) {
            throw new common_1.BadRequestException(error);
        }
    }
    /** Fetches insurer contacts by insurer ID. */
    async fetchInsurerContacts(insurerId) {
        try {
            const insurerContacts = await this.insurerContactRepository.find({
                where: { insurer: { id: insurerId } },
                relations: ["contact"],
            });
            if (!insurerContacts || insurerContacts.length === 0) {
                return [];
            }
            return insurerContacts;
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                throw error;
            }
            throw new common_1.InternalServerErrorException(`Failed to fetch contacts for insurer with ID ${insurerId}.`);
        }
    }
};
exports.InsurerRepository = InsurerRepository;
exports.InsurerRepository = InsurerRepository = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__param(0, (0, typeorm_1.InjectRepository)(insurer_entity_1.Insurer)),
    tslib_1.__param(1, (0, typeorm_1.InjectRepository)(insurer_contact_entity_1.InsureContact)),
    tslib_1.__param(2, (0, typeorm_1.InjectRepository)(insurer_address_entity_1.InsurerAddress)),
    tslib_1.__param(3, (0, typeorm_1.InjectRepository)(look_up_entity_1.LookUp)),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _a : Object, typeof (_b = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _b : Object, typeof (_c = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _c : Object, typeof (_d = typeof typeorm_2.Repository !== "undefined" && typeorm_2.Repository) === "function" ? _d : Object, typeof (_e = typeof entity_service_utils_1.EntityService !== "undefined" && entity_service_utils_1.EntityService) === "function" ? _e : Object, typeof (_f = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _f : Object])
], InsurerRepository);
